<template>
  <transition name="slide-up-fade" mode="out-in">
    <div
      data-component="iorder-checkout-modal"
      v-tiled-background-image="$store.getters['ui/getBackgroundImage']"
      v-background-color="$store.getters['ui/getBackgroundColor']"
    >
      <header data-element="subheading">
        <h3
          data-element="table-number"
          v-font-style="this.$store.getters['ui/getHeadingFontDetail']"
          v-color="this.$store.getters['ui/getPrimaryColor']"
          v-modify-leading="this.$store.getters['ui/getHeadingFontDetail']"
          :style="{ fontSize: '20px' }"
        >
          <template v-if="tableNumber && !collectOnly">
            Table {{ tableNumber }}
          </template>
          <template v-else>
            Payment
          </template>
        </h3>
        <Icon
          :icon="'close'"
          clickable="true"
          @click.native="$store.dispatch('iOrderCheckout/hideModal')"
        />
      </header>
      <template v-if="!hideAlcoholNotice">
        <div
          data-element="text-block"
          v-font-style="
            this.$store.getters['ui/getBodyCopyFontDetail']('light')
          "
          :style="{ fontSize: '16px' }"
        >
          If you are purchasing alcohol, you are agreeing that you and the
          intended consumer are over 18. If you cannot produce valid ID on
          request, you will not receive or be refunded for the alcohol
          purchased.
        </div>
        <img
          data-element="drinkaware-info"
          src="@/assets/img/iorder/drink-aware.svg"
          alt="Drinkaware infographic"
        />
      </template>
      <div data-element="payment-discount" v-if="discountCopy">
        {{ discountCopy }}
      </div>

      <div data-element="checkout-footer-container">
        <transition name="fade">
          <div data-element="content" v-if="basketTotal">
            <div
              data-element="subtotal"
              v-if="voucherDiscountAmount || promotionDiscountAmount"
            >
              <div data-element="description">Subtotal:</div>
              <div data-element="amount">£{{ subtotal }}</div>
            </div>
            <div data-element="discount" v-if="promotionDiscountAmount">
              <div data-element="description">Promotion:</div>
              <div data-element="amount">
                - £{{ promotionDiscountAmount.toFixed(2) }}
              </div>
            </div>
            <div data-element="discount" v-if="voucherDiscountAmount">
              <div data-element="description">{{ voucherDiscountText }}</div>
              <div data-element="amount">
                - £{{ voucherDiscountAmount.toFixed(2) }}
              </div>
            </div>
            <div data-element="total">
              <div data-element="description">Total:</div>
              <div data-element="amount">
                £{{ basketTotal | fixedPrice }}
              </div>
            </div>
            <PaymentButtons
              v-if="
                $store.state.iOrderCheckout.requiredCheckoutData.basketTotal
              "
              :options="$store.getters['iOrderCheckout/getPaymentOptions']"
              :successcb="dispatchAlert"
              :failurecb="failure"
              :salesData="salesData"
              :applicationName="applicationName"
              :location="$store.getters['getSite']"
              :tableNumber="tableNumber"
            />
            <payment-security-icons />
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
import Icon from "@/components/ui/Icon";
import PaymentButtons from "@/components/checkout/PaymentButtons";
import PaymentSecurityIcons from "@/components/checkout/PaymentSecurityIcons";

export default {
  props: [
    "headertext",
    "salesData",
    "success",
    "failure",
    "discountCopy",
    "applicationName",
    "location",
    "tableNumber",
    "alertsCode",
    "guestLoginCallback",
    "hideAlcoholNotice",
  ],
  components: {
    Icon,
    PaymentButtons,
    PaymentSecurityIcons,
  },
  computed: {
    collectOnly() {
      const site = this.$store.getters["getSite"];
      return site && site.collectOnly;
    },
    voucherDiscountText() {
      return `${this.voucherDescription} discount:`;
    },
    subtotal() {
      return (
        this.basketTotal +
        this.promotionDiscountAmount +
        this.voucherDiscountAmount
      ).toFixed(2);
    },
    voucherDescription() {
      return (
        this.$store.getters["iOrderCheckout/getVoucherDetail"] &&
        this.$store.getters["iOrderCheckout/getVoucherDetail"].voucher.metaData
          .friendlyName
      );
    },
    promotionDiscountAmount() {
      return Math.abs(
        parseFloat(
          this.$store.getters["iOrderCheckout/getPromotionDiscountAmount"]
        )
      );
    },
    voucherDiscountAmount() {
      return Math.abs(
        parseFloat(
          this.$store.getters["iOrderCheckout/getVoucherDiscountAmount"]
        )
      );
    },
    basketTotal() {
      return this.$store.getters["iOrderCheckout/getBasketTotal"];
    },
  },
  data() {
    return {
      isSubmitting: false,
      email: null,
      password: null,
    };
  },
  methods: {
    getIcon(fieldName) {
      if (!this[fieldName]) {
        return false;
      }
      if (this.errors.first(fieldName)) {
        return "error-form";
      }
      return "correct-form";
    },
    async dispatchAlert() {
      this.success();
      await this.$store.dispatch("iOrderCheckout/dispatchAlert", {
        alertsCode: this.alertsCode,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
@import "@/assets/scss/helpers.scss";
@import "@/assets/scss/iorder-core/form-row.scss";

[data-component="iorder-checkout-modal"] {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  @include whenScreenIs(sm) {
    width: 460px;
    height: 560px;
  }
  [data-element="subheading"] {
    height: 70px;
    color: $black;
    text-align: center;
    position: relative;
    @media only screen and (max-height: 450px) {
      height: 45px;
    }
    [data-element="restaurant-name"] {
      font-weight: 700;
      font-size: 17px;
      line-height: 16px;
      padding-top: 27px;
      @media only screen and (max-height: 450px) {
        padding-top: 16px;
      }
    }
    [data-element="table-number"] {
      font-size: 17px;
      font-weight: 700;
      line-height: 30px;
      padding-top: 20px;
    }
    [data-component="icon"] {
      position: absolute;
      top: 24px;
      right: 24px;
      @media only screen and (max-height: 450px) {
        top: 14px;
        right: 18px;
      }
    }
  }
  [data-element="payment-discount"] {
    margin: 40px 20px;
    text-align: center;
    font-size: 17px;
    line-height: 21px;
    padding: 5px;
    background-color: $jungle-green;
    color: white;
    font-weight: 900;
  }
  [data-element="drinkaware-info"] {
    display: block;
    margin: 0 auto;
    @media only screen and (max-height: 450px) {
      display: none;
    }
  }
  [data-element="text-block"] {
    padding: 0 16px;
    margin: 22px 0;
    text-align: center;
    @media only screen and (max-height: 450px) {
      margin: 5px 0;
    }
  }
  [data-element="order-summary"] {
    padding: 0 16px;
    [data-element="heading"] {
      font-size: 18px;
      line-height: 35px;
      font-weight: 700;
      color: $jungle-green;
      border-bottom: $jungle-green solid 2px;
    }
  }
  [data-element="checkout-footer-container"] {
    position: absolute;
    bottom: 0;
    width: 100%;
    max-height: 100%;
    [data-element="content"] {
      background-color: $white-two;
      padding: 12px 16px;
      display: flex;
      flex-direction: column;
    }
    [data-element="discount"],
    [data-element="subtotal"],
    [data-element="total"] {
      width: 100%;
      display: flex;
      justify-content: space-between;
      [data-element="description"] {
        width: 80%;
      }
    }
    [data-element="discount"],
    [data-element="subtotal"] {
      font-size: 14px;
      font-weight: 400;
      margin-bottom: 5px;
    }
    [data-element="total"] {
      font-size: 18px;
      font-weight: 700;
      margin-bottom: 10px;
    }
  }

  // [data-element='user-details'] {
  // 	background:#ffffff;

  // 	[data-element='form-wrapper'] {
  // 		@include whenScreenIs(sm) {
  // 			display:flex;
  // 			flex-direction:row;
  // 		}

  // 		[data-element='user-form'] {
  // 			padding:0 16px 0;
  // 			max-width:360px;
  //             margin:0 auto;
  //             padding-bottom: 24px;
  // 		}
  // 	}
  // 	[data-element='form-row'] {
  // 		@extend .form-row;
  // 		[data-element='input-wrapper'] {
  // 			position:relative;
  // 			[data-component='icon'] {
  // 				position:absolute;
  // 				right:8px;
  // 				top:12px;
  // 			}
  // 		}
  // 	}
  // }
}
</style>
